import styled from 'styled-components';

export const AddUserPopWrap = styled.div``;